import Vue from 'vue'
import Vuex from 'vuex'

import Global from './modules/global'
import Auth from './modules/auth'
import PageContainer from './modules/pagecontainer'
import Booking from './modules/booking'
import Building from './modules/building'
import Device from './modules/device'
import Location from './modules/location'
import Client from './modules/client'
import Room from './modules/room'
import Manager from './modules/manager'
import Protect from './modules/protect'
import Equipment from './modules/equipment'
import Calendar from './modules/calendar'
import Report from './modules/report'
import Approval from './modules/approval'
import ServiceDesk from './modules/servicedesk'
import Supplier from './modules/supplier'
import CostCenter from './modules/costcenter'
import User from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Global,
    Auth,
    PageContainer,
    Booking,
    Building,
    Device,
    Location,
    Client,
    Room,
    Manager,
    Protect,
    Equipment,
    Calendar,
    Report,
    Approval,
    ServiceDesk,
    Supplier,
    CostCenter,
    User
  }
})
